export default __webpack_public_path__ + "static/media/expand-icon-mobile.69466cec.svg";